export default {
  "b2b.zadosti-row-detail.telefon.label": "Telefon",
  "b2b.zadosti-row-detail.email.label": "E-Mail",
  "b2b.zadosti-row-detail.projekt.label": "Projekt",
  "b2b.zadosti-row-detail.produkt.label": "Produkt",
  "b2b.zadosti-row-detail.doplnkove-sluzby.label": "Doplň. služby",
  "b2b.zadosti-row-detail.poznamky.label": "Poznámky",
  "b2b.zadosti-row-detail.poznamky-zakaznik.label": "Zákazník",
  "b2b.zadosti-row-detail.poznamky-strojvedouci.label": "Strojvedoucí",
  "b2b.zadosti-row-detail.poznamky-spravce.label": "Správce"
};
